import { Fragment, type FC } from 'react';

import { Fab } from '#packages/web/foundations/buttons/fab';
import { EmptyPage, LoadingPage } from '#packages/web/layouts/page/templates';

import { ThrowError } from '#apps/client-web/app/components/throw-error';

import { CreateAuditDialog } from '../../components/create-audit-dialog';

import { type AuditListPageViewModelProps } from './types';

export type AuditListPageContentProps = AuditListPageViewModelProps;

export const AuditListPageContent: FC<AuditListPageContentProps> = ({
  useViewModel,
}: AuditListPageContentProps) => {
  const {
    isLoading,

    isError,
    error,

    createAuditDialog,
    createAudit,
    createAuditCallback,
    isCreating,

    audits,
    hasAudits,
  } = useViewModel();

  return (
    <Fragment>
      {isLoading && <LoadingPage />}

      {/* Unexpected error occurred */}
      {isError && <ThrowError error={error!} />}

      {/* Empty */}
      {!hasAudits && <EmptyPage onActionButtonClick={createAudit} />}

      {/* Audit list */}
      {hasAudits && <div>{audits?.length}</div>}

      {/* Extra elements (e.g. dialogs, FABs) */}
      {!isError && !isLoading && hasAudits && <Fab onClick={createAudit} />}
      {createAuditDialog.state === 'open' && (
        <CreateAuditDialog
          open
          onClose={createAuditDialog.close.bind(undefined, undefined)}
          onFormSubmit={createAuditCallback}
          onFormCancel={createAuditDialog.close}
          state={isCreating ? 'mutating' : 'idle'}
          initialValue={createAuditDialog.data}
        />
      )}
    </Fragment>
  );
};

export default AuditListPageContent;
